import React from 'react';
import type { SxProps, Theme } from '@mui/material';
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
} from '@mui/material';

export interface AccordionProps {
  children: NonNullable<React.ReactNode>;
  className?: string;
  expanded?: boolean;
  defaultExpanded?: boolean;
  disabled?: boolean;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
  sx?: SxProps<Theme>;
  TransitionProps?: object;
  elevation?: number;
  disableGutters?: boolean;
}

export interface AccordionSummaryProps {
  children: NonNullable<React.ReactNode>;
  className?: string;
  expandIcon?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export interface AccordionDetailsProps {
  children: NonNullable<React.ReactNode>;
  className?: string;
  sx?: SxProps<Theme>;
}

/**
 * Generic wrapper around MUI Accordion
 * Pass all styling via sx prop, className, or other MUI props
 */
const Accordion: React.FC<AccordionProps> = (props) => {
  return <MuiAccordion {...props} />;
};

/**
 * Generic wrapper around MUI AccordionSummary
 * Pass all styling via sx prop, className, or other MUI props
 */
const AccordionSummary: React.FC<AccordionSummaryProps> = (props) => {
  return <MuiAccordionSummary {...props} />;
};

/**
 * Generic wrapper around MUI AccordionDetails
 * Pass all styling via sx prop, className, or other MUI props
 */
const AccordionDetails: React.FC<AccordionDetailsProps> = (props) => {
  return <MuiAccordionDetails {...props} />;
};

export { Accordion, AccordionDetails, AccordionSummary };

export default Accordion;
